import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSafeRedirectUrl } from '../enum/UrlAppMap';

const Unauthorized = () => {
  const navigate = useNavigate();
  const [retryUrl, setRetryUrl] = useState('/');

  useEffect(() => {
    // Check for URL from authorization failure (when user was denied access)
    const unauthorizedUrl = sessionStorage.getItem('unauthorized_redirect_url');
    
    if (unauthorizedUrl) {
      const safeUrl = getSafeRedirectUrl(unauthorizedUrl);
      setRetryUrl(safeUrl);
    }
    // If no stored URL, retryUrl remains as default '/' (home page)
  }, []);  const handleRetry = () => {
    navigate(retryUrl);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 3,
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Unauthorized Access
        </Typography>
        <Typography variant="body1">You do not have permission to view this page.</Typography>
      </Box>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Please contact your administrator for access.
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Button variant="contained" color="primary" onClick={handleRetry}>
          Retry
        </Button>
      </Box>
    </Box>
  );
};

export default Unauthorized;
